const FAVORITE_HOVER_TITLES = {
  CLIP: ['Aflevering toevoegen aan Mijn JUKE', 'Aflevering verwijderen uit Mijn JUKE'],
  PODCAST: ['Podcast toevoegen aan Mijn JUKE', 'Podcast verwijderen uit Mijn JUKE'],
  SHOW: ['Show toevoegen aan Mijn JUKE', 'Show verwijderen uit Mijn JUKE'],
  STATION: ['Station toevoegen aan Mijn JUKE', 'Station verwijderen uit Mijn JUKE'],
  TRACK: ['Nummer toevoegen aan Mijn JUKE', 'Nummer verwijderen uit Mijn JUKE'],
};

export { FAVORITE_HOVER_TITLES as default };
